module.exports = __webpack_public_path__ + "img/content_copy.2bef28be.svg";